import { useTheme } from '@mui/material';
import { computeComponentColors, resolveColorMain } from '@europrocurement/flexy-components';

export function useWidgetColors(color: string) {
    const { palette } = useTheme();

    const colorMain = resolveColorMain(color, palette);

    const paletteColor = palette[color as keyof typeof palette] as
        | { main: string; dark?: string }
        | undefined;

    const colorDark = paletteColor?.dark ?? palette.primary.dark;

    // Use pre-computed palette tokens when available, fall back to runtime computation
    const token = palette.icon?.[color] ?? computeComponentColors(colorMain, palette.mode);

    const iconBg = token.glassyStyle;
    const iconActiveBg = token.glassyStyleOnHover;
    const buttonBgFlat = token.backgroundColor;
    const buttonTextColor = token.textColor;

    const actionButtonSx = {
        maxHeight: '50px',
        ...token.glassyStyle,
        color: buttonTextColor,
        textTransform: 'none' as const,
        fontWeight: 600,
        fontSize: '14px',
        whiteSpace: 'nowrap',
        borderRadius: '8px',
        boxShadow: 'none',
        '&:hover': {
            ...token.glassyStyleOnHover,
            color: token.textColorOnHover,
            boxShadow: 'none',
        },
    };

    return {
        colorMain,
        colorDark,
        iconBg,
        iconActiveBg,
        buttonBgFlat,
        buttonTextColor,
        bgPaper: palette.background.paper,
        actionButtonSx,
    };
}
